import React, { useMemo } from "react";
import PropTypes from "prop-types";

import  { Card } from "rhombus-react";

import { CAROUSEL_AD_TYPES } from "utils/constants";
import { MAX_CAROUSEL_CARDS_BY_ADTYPE, UNEDITABLE_CARD_MESSAGE } from "social/constants/common";

import CardHeader from "./CardHeader";
import CardSelector from "./CardSelector";

import "./CardContent.css";

export default function CardContent(props){
	const {
		libraryId,
		adType,
		isViewOnly,
		showPristineErrors,
		navigationActions,
		CardForm,
		doVersionsExist,
		customHeadingDesctiption,
		extraCardHeaderProps = {},
	} = props;

	if (doVersionsExist) {
		extraCardHeaderProps.deleteCardTooltip = UNEDITABLE_CARD_MESSAGE;
		extraCardHeaderProps.duplicateCardTooltip = UNEDITABLE_CARD_MESSAGE;
	}

	const headingDescription = useMemo(() => {
		if (typeof customHeadingDesctiption !== 'undefined') {
			return customHeadingDesctiption;
		}

		const maxCards = MAX_CAROUSEL_CARDS_BY_ADTYPE[adType];
		return `Carousel must contain between 2-${maxCards} cards`;
	}, [customHeadingDesctiption, adType]);

	return (
		<Card
			className="carousel-card-content"
			header = {(
				<span className="c-heading-descriptive">
					{headingDescription}
				</span>
			)}
			isCollapsable
			isVisible
		>
			<CardSelector
				adType={adType}
				libraryId={libraryId}
				isViewOnly={isViewOnly || doVersionsExist}
				showPristineErrors={showPristineErrors}
			/>
			<div className="form-container">
				<CardHeader adType={adType} isViewOnly={isViewOnly || doVersionsExist} {...extraCardHeaderProps} />
				<CardForm
					libraryId = {libraryId}
					isViewOnly = {isViewOnly}
					showPristineErrors = {showPristineErrors}
					navigationActions = {navigationActions}
					adType = {adType}
					doVersionsExist = {doVersionsExist}
				/>
			</div>
		</Card>
	);
}

CardContent.displayName = "CardContent";
CardContent.propTypes = {
	libraryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	adType: PropTypes.oneOf(CAROUSEL_AD_TYPES),
	showPristineErrors: PropTypes.bool,
	navigationActions: PropTypes.object,
};
